module.exports = __webpack_public_path__ + "img/20200609_144446.0370c6f6.jpg";